import Vue from 'vue'
import Router from 'vue-router'
import Guru from '@/components/Guru'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/guru/:id',
      name: 'ShareGuru',
      components: {
        default: Guru
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js